import { RefreshCw, ShieldCheck } from "lucide-react";

/**
 * The refusal a non-admin sees on an admin-only page: the Admin page's own,
 * and (#4733) AppShell's on every ADMIN_ROUTE_PAGES route. `station`: an
 * admin in a station PIN session, which the server refuses every /api/admin
 * read (isPinSessionRefusedPath), so the page could only fail there.
 * `onRecheck` (#4922): the gate's refusal can ask the server again, for
 * someone made an admin since it last asked.
 */
export function AdminOnlyNotice({ station = false, onRecheck }: { station?: boolean; onRecheck?: () => void }) {
  return (
    <div data-testid="admin-only-notice" className="mx-auto max-w-md py-24 text-center">
      <ShieldCheck className="mx-auto h-10 w-10 text-muted-foreground/30" />
      <h2 className="mt-4 text-lg font-semibold">Access Denied</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        {station
          ? "Admin pages do not open in a station PIN session. Sign in with your own account to use this page."
          : "This page is restricted to administrators."}
      </p>
      {onRecheck ? (
        <button
          type="button"
          onClick={onRecheck}
          className="mt-4 inline-flex min-h-11 items-center gap-1.5 rounded-md border border-border px-3 text-sm font-medium hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <RefreshCw className="h-3.5 w-3.5" aria-hidden="true" />
          Check again
        </button>
      ) : null}
    </div>
  );
}
